import { render, staticRenderFns } from "./PdfPreviewPage2.vue?vue&type=template&id=22265514&"
import script from "./PdfPreviewPage2.vue?vue&type=script&lang=js&"
export * from "./PdfPreviewPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports